import SVG from "react-inlinesvg";

import { Badge, Box, Popover, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import NotificationsIcon from "@material-ui/icons/Notifications";

import { makeStyles } from "@material-ui/styles";
import { toAbsoluteUrl } from "../../../../../_helpers";
import BaseNotificationDropdownCard from "./BaseNotificationDropdownCard";
import NotificationsModal from "./NotificationsModal";
import { UserProfilePrefs } from "../../../../../../app/modules/Helpers/UserProfilePrefs";
import { useIntl } from "../../../../../i18n/customUseIntl";
import { headerMenusStyles } from "../../../../_core/MaterialThemeProvider";
import { Bell01 as NewNotificationsIcon } from "@untitledui/icons";
import featureFlags from "../../../../../../app/sustell_15/utils/featureFlags";

const useStyles = makeStyles({
  root: {
    width: 360,
    display: "flex",
    flexDirection: "column",
  },
  header: {
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 28,
    paddingBottom: 28,
    borderRadius: 0,
    backgroundColor: "#49AB6C",
    backgroundImage: "url(" + toAbsoluteUrl("/media/bg/wave.svg") + ")",
  },
  notificationsContainer: {
    height: 360,
  },
  noNotifications: {
    height: 360,
    padding: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
});

type Notification = {
  id: string;
  title: string;
  message: string;
  publishAt: string;
  expiresAt: string;
  category: string;
  attachementKeys: string[] | null;
  isWelcome: boolean;
};

export default function NotificationDropdown() {
  const intl = useIntl();

  const [openModal, setOpenModal] = React.useState(false);
  const [selected, setSelected] = React.useState<Notification[]>([]);
  const [open, setOpen] = React.useState<boolean>(false);

  const buttonRef = React.useRef(null);
  const classes = useStyles();
  const commonClasses = headerMenusStyles();
  const [notifications, setNotifications] = React.useState<any>();

  const wait = async () => {
    await new Promise((r) => setTimeout(r, 2000));
  };

  useEffect(() => {
    UserProfilePrefs.getInstance().reloadNotifications();
    setNotifications(UserProfilePrefs.getInstance().getNotifications());
  }, []);

  useEffect(() => {
    const notificationsOpen = localStorage.getItem('notificationsOpen');

    if (notificationsOpen) {
      wait().then(() => {
        UserProfilePrefs.getInstance().reloadNotifications();
        setNotifications(UserProfilePrefs.getInstance().getNotifications());
        setOpen(JSON.parse(notificationsOpen));
      });
    }
  }, []);

  const toggleDropdown = () => {
    localStorage.setItem('notificationsOpen', JSON.stringify(!open));
    setOpen(!open);
  }

  const handleNotificationClick = (notification: Notification) => {
    setSelected([notification]);
    setOpenModal(true);
  }

  return (
    <React.Fragment>
      <div
        className={(commonClasses as any).mainMenuItemIcon}
        onClick={toggleDropdown}
        ref={buttonRef}
      >
        <Badge badgeContent={notifications?.length} color="error" overlap="rectangular">
          <NewNotificationsIcon fontSize="medium" width={20} height={20} />
        </Badge>
      </div>

      <Popover
        open={open}
        anchorEl={buttonRef.current}
        onClose={toggleDropdown}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box className={classes.root}>
          <Box className={classes.header}>
            <Typography style={{ color: 'white' }} variant="h5">
              {intl.formatMessage({ id: "NOTIFICATIONS" })}
            </Typography>
          </Box>

          {notifications?.length > 0 ? (
            <Box className={classes.notificationsContainer}>
              {notifications.map((notification: Notification) => {
                return (
                  <BaseNotificationDropdownCard
                    key={notification.title + notification.publishAt}
                    title={notification.title}
                    message={notification.message}
                    onClick={() => handleNotificationClick(notification)}
                  />
                );
              })}
            </Box>
          ) : (
            <Box className={classes.noNotifications}>
              <Typography variant="h5">{intl.formatMessage({ id: "NOTIFICATIONS.NO_NOTIFICATIONS" })}</Typography>
              <Typography
                color="textSecondary"
                variant="body1"
                style={{ maxWidth: 260, textAlign: "center" }}
              >
                {intl.formatMessage({ id: "NOTIFICATIONS.NO_NOTIFICATIONS.INFO" })}

              </Typography>
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/mailbox.svg")}
              />
            </Box>
          )}
        </Box>
      </Popover>
      <NotificationsModal data={selected} open={openModal} onClose={() => setOpenModal(false)} />
    </React.Fragment >
  );
}
